// extracted by mini-css-extract-plugin
export var container = "CoreValue-module--container--1Kw4n";
export var firstWord = "CoreValue-module--first-word--pVWjw";
export var secondWord = "CoreValue-module--second-word--3I6Hx";